// extracted by mini-css-extract-plugin
module.exports = {"appointment_header1":"BookAppointment_appointment_header1__3k613","appointment_header2":"BookAppointment_appointment_header2__1Jatx"};